// Ottelumuoto (Teams / sarjaottelut). docs/features/teams.md §4.2.
//
// A format is the MENU, not a validator: it says which rubbers a tie may contain and how many
// of each, and the manager is never offered anything else. There is deliberately no offset, no
// parallel/sequential flag and no ordering - layout is the home team's call, and nothing in the
// feature checks it.
//
// Each row carries an `id` because a booking names a ROW, never a duration (§4.2). firebase.js
// mints one on save for any row that lacks it.

import { RUBBER_TYPES } from '../../utils/teamformats'

const _teamFormatRubberClass = {
  type: {
    type: 'string',
    title: 'Ottelutyyppi',
    default: 'single',
    oneOf: RUBBER_TYPES.map((t) => ({ const: t.const, title: t.title })),
  },
  count: {
    type: 'number',
    title: 'Määrä',
    default: 1,
    minimum: 1,
  },
  duration: {
    type: 'number',
    title: 'Kesto (min)',
    default: 90,
    minimum: 1,
  },
}

export const _teamFormatClass = {
  name: { type: 'string', title: 'Ottelumuodon nimi, esim. Miesten 3. divisioona' },
  description: { type: 'string', title: 'Kuvaus' },
  active: { type: 'boolean', title: 'Active', default: true },
  rubbers: {
    type: 'array',
    title: 'Ottelut',
    items: {
      type: 'object',
      properties: _teamFormatRubberClass,
      required: ['type', 'count', 'duration'],
    },
  },
}

export const _teamFormatUISchema = {
  name: {
    'ui:help': 'Näkyy joukkueenjohtajalle varausta tehtäessä.',
  },
  rubbers: {
    'ui:help':
      'Montako ottelua ja minkä mittaisina. Järjestys, kellonajat ja kentät ovat ' +
      'joukkueenjohtajan valittavissa - tämä määrittää vain mitä saa varata ja kuinka monta.',
    items: {
      duration: {
        'ui:help': 'Minuutteina, esim. 90.',
      },
    },
  },
}
